var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionButtonOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.063,
    height: 15.288,
    viewBox: "0 0 12.063 15.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843",
    transform: "translate(11373.25 4922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13598",
    "data-name": "Path 13598",
    d: "M0,2.832,3.079,0,6.1,2.832",
    transform: "translate(-11371.094 -4912.3) rotate(-45)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M8.6,15.054H1.613A1.615,1.615,0,0,1,0,13.442V1.612A1.615,1.615,0,0,1,1.613,0H8.172V3.653h3.656v8.175H10.753v-7.1H8.172A1.076,1.076,0,0,1,7.1,3.653V1.075H1.613a.538.538,0,0,0-.538.537V13.442a.538.538,0,0,0,.538.537H8.6v1.074Z",
    transform: "translate(-11373.25 -4922)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13871",
    "data-name": "Path 13871",
    d: "M-11365.622-4922l3.688,3.627V-4917l-5.24-5Z",
    transform: "translate(0.511)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13597",
    "data-name": "Path 13597",
    d: "M0,9.766V0",
    transform: "translate(-11368.8 -4914.325) rotate(-45)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonOpen);
export default __webpack_public_path__ + "static/media/action_button_open.7034c4b4b006c9fc33a96b4face56996.svg";
export { ForwardRef as ReactComponent };